<template>
  <div class="canvas-item" id = 'MapWrapper' style="width:100%;" ontouchstart="">
      <div id = "CanvasWrapper">
        <canvas :ref="'canvas' + data.index" id="canvas" v-bind="mapsize" style="width:100%;"></canvas>
      </div>    
  </div>
</template>

<script>
import map_config from './map_config.js';

var mapwidth = 0;
var mapheight = 0;
var boxwidth;
var boxheight;
var thresholds;
var img_width = -1;
var img_height = -1;
var box_width = -1;
var box_height = -1;

console.log("garb", thresholds, img_width, img_height, box_height, box_width, boxheight, boxwidth)
 

export default {
  name: 'CanvasCard',  
  data: () =>  {
    return {
      campus: -1,
      building: -1,
      floor: -1,
      access_points: null,
      ap_data: null,
      mapsize:{
        width:mapwidth,
        height:mapheight
      },
      options: {
        responsive: true
      },
    }
  },
  props: {
      'data': Object,
  },
  methods: {

        drawCanvas(fileData, access_points, ap_data) {   
          const ctx = this.$refs["canvas"+String(this.data.index)].getContext('2d');
          //configs
          var font_size = 15;
          var center_size = 15;
          var yohaku = 0.9;
          //configs
          var img = new Image();
          img.onload = function(){
            
            // ctx.clearRect(0, 0, box_width, box_height); // canvasをクリア
            var scale = 1.0;//実寸サイズ
            if(box_width/img.naturalWidth < box_height/img.naturalHeight){
              scale = box_width/img.naturalWidth              
            }
            else{
              scale = box_height/img.naturalHeight
            }
            scale = scale*yohaku
            mapwidth = scale*img.naturalWidth; mapheight = scale*img.naturalHeight;
            font_size = scale*font_size; center_size = scale*center_size;
            ctx.font = String(font_size)+'pt Arial';
            var shift_x = (box_width - mapwidth) / 2
            var shift_y = (box_height - mapheight)/2
            ctx.drawImage(this, 0, 0, img.naturalWidth, img.naturalHeight, shift_x, shift_y, mapwidth, mapheight);            
            
            for(let i in access_points){
              let xpos = access_points[i]["xpos"]; let ypos = access_points[i]["ypos"];
              var fillstyle = "rgba(255,0,255, 0.8)"
              for(let j = 0; j < thresholds.length-1; j++){
                if(thresholds[j].threshold < ap_data[i] && ap_data[i] < thresholds[j+1].threshold){
                  var rgb = thresholds[j+1].rgb                  
                  fillstyle = "rgba("+ rgb[0] + "," + rgb[1] + ","+rgb[2]+", 0.05)";
                }
              }
              ctx.fillStyle = fillstyle; 
              for(let j=0; j<8; j++){
                  ctx.beginPath()                                          
                  ctx.arc( shift_x + scale*xpos, shift_y + scale*ypos, center_size+j*(5*scale), 0 * Math.PI / 180, 360 * Math.PI / 180, false );
                  ctx.strokeStyle = "rgba(0,0,0,0.2)"; ctx.stroke();
                  ctx.fill();
              } 
              fillstyle = "rgba(255,255,255,0.5)"; ctx.fillStyle = fillstyle;               
              ctx.beginPath()                                          
              ctx.arc( shift_x + scale*xpos, shift_y + scale*ypos, center_size, 0 * Math.PI / 180, 360 * Math.PI / 180, false );
              ctx.fill();         
              ctx.fillStyle = "rgba(0,0,0,1)" ; ctx.fillText(ap_data[i],  shift_x + scale*xpos-(font_size/2), shift_y + scale*ypos+(font_size/2))
            }      
            ctx.fillStyle = "rgba(0,0,0,0.0)"      
            ctx.fillRect(0,0,box_width, box_height)
            
          }
          
          img.src = fileData;
          img.onerror = function() {
            ctx.font = '50pt Arial' ;
            ctx.fillText('表示する画像が見つかりません', 50, 100);
        }
    },
    SetConfigs(){
      thresholds = map_config.thresholds
      img_width = map_config.image_size.max_width;
      img_height = map_config.image_size.max_height;

      box_width = map_config.canvas_size.max_width;
      box_height = map_config.canvas_size.max_height;   
      if(img_width/img_height < box_width/box_height){        
        box_width = box_width*(img_height/box_height)
        box_height = img_height
      }
      else{
        box_height = box_height*(img_width/box_width)
        box_width = img_width
      }
      this.mapsize.width = box_width 
      this.mapsize.height = box_height
    }
  },
  mounted() {
    this.SetConfigs()
    this.drawCanvas(this.data.fileData, this.data.access_points, this.data.ap_data)    
  }  
}
</script>

<style>
#CanvasWrapper {
  /* box-shadow: 0px 0px 5px 5px rgba(128, 128, 128, 0.589) inset; */
  /* padding:15px; */
}

div {
	margin: 0px;
	padding: 0px;
	text-align: left;
}
#MapWrapper{
  z-index: 1; 
}
.canvas-item{
  background-color:white;
}

.ghost .canvas-item{
  opacity: 0.3;
  background: #96d2ee;
}


</style>
